import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { ArticleMagazineModel, MutationArticleMagazineRecommandationArgs } from 'src/graphql/generated-types';
import { UserState } from 'src/app/_user/store/user/user.state';
import { Store } from '@ngxs/store';
import { IGNORE_ALL_GRAPHQL_ERRORS } from 'src/app/_core/graphql.module';
import { catchError } from 'rxjs/operators';

export enum MagazineActionEnum {
    Detail = 'Clic sur le détail',
    Like = 'Like',
    Unlike = 'Unlike',
    ShareMail = 'Partager par mail',
    SharePortal = 'Partager sur le portail',
    Close = 'Quitte l\'écran de l\'article',
}

export type MagazineActionType = keyof typeof MagazineActionEnum;

@Injectable({
    providedIn: 'root'
})
export class MagazineService {
    constructor(private readonly graphqlService: GraphqlService,
                private readonly store: Store) {
    }

    public magazineAction(magazine: ArticleMagazineModel, action: MagazineActionType): Observable<boolean> {
        const IdUser = this.store.selectSnapshot(UserState.connectedUser).Id;

        return this.graphqlService.mutateOne<'ArticleMagazineRecommandation', MutationArticleMagazineRecommandationArgs>({
            mutation: gql` mutation ArticleMagazineRecommandation( $contexte: ContextInfosInput, $criteres: CriteresRecoActionDTOInput) {
                ArticleMagazineRecommandation( contexte: $contexte, criteres: $criteres )
            }
            `, context: {
                [IGNORE_ALL_GRAPHQL_ERRORS]: true
            },
            variables: {
                criteres: {
                    IdArticle: +magazine.Id,
                    Action: action,
                    IdUser
                }
            }
        });
    }
}
